import React from "react";
import MarcarPresencaLayer from "../components/MarcarPresencaLayer";

const MarcarPresencaPage = () => {
  return (
    <>
      {/* MarcarPresencaLayer */}
      <MarcarPresencaLayer />
    </>
  );
};

export default MarcarPresencaPage;
